module.exports = __webpack_public_path__ + "static/media/oea1.ded8638e.jpg";